$(document).ready(function() {
  $(document).on('click', '.mobile-menu-icon', function() {
     $('.mobile-megamenu').toggleClass('open-menu');
     $('.mobile-header-sidebar').toggleClass('open-wrapper');
     $('body').toggleClass('opened-drawer');
     $('.overlay-content').toggleClass('open-overlay');
   });

   $(document).on('click', '.close-button', function() {
      $('.mobile-megamenu').removeClass('open-menu');
      $('.mobile-header-sidebar').removeClass('open-wrapper');
      $('body').removeClass('opened-drawer');
      $('.overlay-content').removeClass('open-overlay');      
      $('.mobile-megamenu-product').removeClass('show');
      $('.mobile-header-menu-nav').removeClass('submenu-open');
      $('.drawer-main').removeClass('main-submenu-open');
      $('.mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
      $('.sublink-dropdown-wrapper').removeClass('open-childmenu-wrapper');
      $('.sublink-dropdown').removeClass('show');
    });

    $(document).mouseup(function (e) {
       var container = $('.mobile-megamenu');
       if (!container.is(e.target) && container.has(e.target).length === 0 && $('.mobile-megamenu').hasClass('open-menu')) {
       $('.mobile-megamenu').removeClass('open-menu')
       $('.overlay-content').removeClass('open-overlay')
       $('body').removeClass('opened-drawer');
       }
   });

    $(document).on('click','.back-section',function(event) {
      event.preventDefault();
      $('.mobile-megamenu-product').removeClass('show');
      $('.mobile-header-menu-nav').removeClass('submenu-open');
      $('.drawer-main').removeClass('main-submenu-open');
       $('.mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
     });

    $(document).on('click', '.drawer-main .has-megmenu', function(event) {
        event.preventDefault();
        
        $('.mobile-header-menu-nav').addClass('submenu-open');
        $('.drawer-main').addClass('main-submenu-open');
        
        var $submenu = $(this).next();
        
        if ($submenu.hasClass('show')) {
            $submenu.removeClass('show');
            $submenu.find('.mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
        } else {
            $(this).parent().parent().find('.mobile-list-menu-item .mobile-megamenu-product').removeClass('show');
            $submenu.addClass('show');
            setTimeout(function(){
               $submenu.find('.mobile-submenu-wrapper').addClass('open-submenu-wrapper');
            }, 330);

        }
    });


      $(document).on('click', '.drawer-main .menu-child-link', function(event) {
        event.preventDefault();
        var $childmenu = $(this).next();
        
        if ($childmenu.hasClass('show')) {
            $childmenu.removeClass('show');
            $childmenu.find('.sublink-dropdown-wrapper').removeClass('open-submenu-wrapper');
        } else {
            $(this).parent().parent().find('.megamenu-items .sublink-dropdown').removeClass('show');
            $childmenu.addClass('show');
            setTimeout(function(){
               $childmenu.find('.sublink-dropdown-wrapper').addClass('open-childmenu-wrapper');
            }, 330);

        }
    });

      $(document).on('click','.child-back-section',function(event) {
      event.preventDefault();
        $('.sublink-dropdown').removeClass('show');
         $('.sublink-dropdown-wrapper').removeClass('open-childmenu-wrapper');
      });
  
});
